import { Component } from '@verndale/core';
import { disableButton, enableButton } from '../utils/forms';
import Pristine from 'pristinejs';
import axios from 'axios';
import serialize from 'form-serialize';
import {
  PRISTINE_SETTINGS,
  SERIALIZE_SETTINGS
} from '../utils/default-settings';
import MicroModal from 'micromodal';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $requestForm: this.el._$('.gps-module__request-form'),
      $reportstForm: this.el._$('.gps-module__reports-form'),
      $desc1: this.el._$('.modal-gps__request-description'),
      $desc2: this.el._$('.modal-gps__reports-description'),
      $radioGroup: this.el._$('.gps-module__reports-form .radio-group'),
      $gpsError: this.el._$('.gps-component__error'),
      $nextButton: this.el._$('.gps-module__request-form .field__submit'),
      $submit: this.el._$('.gps-module__reports-form .field__submit'),
      $lotNumber: this.el._$('#lotNumber'),
      $modal: document._$('#modal-gps'),
      $closeButton: this.el._$('.gps-module__close-link'),
      $genericCloseModal: document._$('.modal-gps .generic-modal__close')
    };

    this.modalId = this.dom.$modal.getAttribute('id') || null;

    this.modalInit();
    this.pristineInit();
  }

  addListeners() {
    if (this.dom.$requestForm) {
      this.dom.$requestForm._on('submit', this.handleSubmit.bind(this));
      this.dom.$requestForm._on('input', this.enableDisableNextBtn.bind(this));
    }

    if (this.dom.$reportstForm) {
      this.dom.$reportstForm._on('submit', this.handleReportSubmit.bind(this));
    }

    if (this.dom.$closeButton) {
      this.dom.$closeButton._on('click', this.resetModal.bind(this));
    }

    if (this.dom.$genericCloseModal) {
      this.dom.$genericCloseModal._on('click', this.resetModal.bind(this));
    }


  }

  pristineInit() {
    const { $requestForm } = this.dom;

    if ($requestForm) {
      this.pristineForm = new Pristine($requestForm, PRISTINE_SETTINGS);
    }
  }

  modalInit() {

    if (this.modalId) {
      MicroModal.init({
        onClose: modal => {
          this.resetModal();
        },
        openTrigger: 'data-generic-modal-open',
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      });
    }
  } //modalInit

  enableDisableNextBtn() {
    const { $nextButton } = this.dom;

    try {
      const valid = this.pristineForm.validate(true);
      $nextButton.disabled = !valid;
    } catch (error) {
      return;
    }
  }

  enableDisableSubmitBtn() {
    const { $submit } = this.dom;
    if (this.dom.$reportstForm._$('input[name="gps-document"]:checked')) {
      enableButton($submit);
    } else {
      disableButton($submit);
    }
  }

  handleReportSubmit(e) {
    e.preventDefault();
    const url = this.dom.$reportstForm._$('input[name="gps-document"]:checked').value;
    window.open(url, '_blank');
    this.resetModal();
    this.closeModal();
  }

  closeModal() {
    this.dom.$modal.classList.remove('generic-modal--open');
  }

  resetModal(e) {
    e?.preventDefault();
    this.dom.$requestForm.classList.remove('hidden');
    this.dom.$reportstForm.classList.add('hidden');
    this.dom.$radioGroup.innerHTML = '';
    this.dom.$lotNumber.classList.remove('field__input--success');
    this.dom.$gpsError.classList.add('hidden');
    this.dom.$requestForm.reset();
    this.pristineForm.destroy();
    disableButton(this.dom.$submit)
    this.pristineInit();
  }

  handleSubmit(e) {
    e.preventDefault();
    disableButton(this.dom.$nextButton);
    const url = this.dom.$requestForm.action;
    const formData = serialize(this.dom.$requestForm, SERIALIZE_SETTINGS);
    const that = this;
    axios({
      method: 'post',
      url,
      data: formData,
      headers: {
        'content-type': 'application/json'
      }
    }).then(response => {
      const { success, message, body } = response?.data;
      if (success) {
        body.documents.forEach((document, index) => {
          const radio = `<input id="${document.name.replace(' ', '_')}" name="gps-document" class="field__radio" type="radio" value="${document.url}" ${index===0?'checked':''}> <label for="${document.name.replace(' ', '_')}" class="field__label">${document.name}</label>`;
          that.dom.$radioGroup.innerHTML += radio;
        });
        that.dom.$requestForm.classList.add('hidden');
        that.dom.$reportstForm.classList.remove('hidden');
        that.dom.$desc1.classList.add('hidden');
        that.dom.$desc2.classList.remove('hidden');
        that.dom.$gpsError.classList.add('hidden');
        that.enableDisableSubmitBtn();
        document._$$('input[name="gps-document"]')?._on('change', that.enableDisableSubmitBtn.bind(that));
      } else {
        that.dom.$requestForm.classList.remove('hidden');
        that.dom.$reportstForm.classList.add('hidden');
        that.dom.$desc1.classList.remove('hidden');
        that.dom.$desc2.classList.add('hidden')
        that.dom.$gpsError.innerHTML = message;
        that.dom.$gpsError.classList.remove('hidden');
        disableButton(that.dom.$nextButton);
      }
    });

  }
}

export default Module;
